/*
 * Module for the Participant Home User Flags menu
*/

rs.module("participant/home/userflagsmenu",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _userFlags;

        function initialize(jsSelectors, cssClasses, backendUrls) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _userFlags = $.js(_jsSelectors.userFlags);

            // show/hide user flags menu when toggle button is clicked
            _userFlags.js(_jsSelectors.toggle).click(function () {
                _userFlags.js(_jsSelectors.menu).toggle();
            });

            // hide user flags menu if user clicks anywhere outside of it
            $("body").click(function (event) {
                if ($(event.target).closest(`[data-js~=${_jsSelectors.userFlags}`).length == 0) {
                    _userFlags.js(_jsSelectors.menu).hide();
                }
            });

            // subscribe/unsubscribe to user flag
            _userFlags.js(_jsSelectors.flagCheckbox, { multiple: true, required: false }).change(function () {

                $.post(backendUrls.saveUserFlag,
                    {
                        "userflagkey": $(this).data("userflagkey"),
                        "flagvalue": $(this).is(":checked"),
                        "ownerkey": $(this).data("ownerkey"),
                        "grouptype": $(this).data("grouptype"),
                        "accountkey": $(this).data("accountkey")
                    });

                _toggleUserFlagsIcon();
            });

            // Hookup change event to save attributes
            _userFlags.js(jsSelectors.keyEmployeeCheckbox, { required: false }).change(saveAttributes);

            // Hookup change event to save attributes
            _userFlags.js(jsSelectors.highlyCompensatedCheckbox, { required: false }).change(saveAttributes);

            //
            // Function to save member attributes
            //
            function saveAttributes() {

                // Even though this is being sent as an HTTP GET, this is the call that is doing the save of the attributes
                $.post(
                    backendUrls.saveMemberAttributes,
                    {
                        keyEmployee: _userFlags.js(jsSelectors.keyEmployeeCheckbox, { required: false }).is(":checked"),
                        highlyCompensated: _userFlags.js(jsSelectors.highlyCompensatedCheckbox, { required: false }).is(":checked")
                    }
                );

                _toggleUserFlagsIcon();
            }
        }

        //
        // Toggle user flag icon based on whether any flags or attributes are selected
        //
        function _toggleUserFlagsIcon() {

            var flagSelected = _userFlags.js(_jsSelectors.flagCheckbox, { multiple: true, required: false }).filter(":checked").length > 0;

            var attributeSelected = _userFlags.js(_jsSelectors.attributeCheckbox, { multiple: true, required: false }).filter(":checked").length > 0;

            _userFlags.js(_jsSelectors.flagIcon).toggleClass(_cssClasses.solid, flagSelected || attributeSelected);
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);